import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import StandardModal from 'components/consumer/StandardModal';
import CtaButton from 'components/essentials/Cta/CtaButton';
import PDPOrderSwatchesSidebar from 'components/consumer/PDP/PDPOrderSwatchesSidebar';
import useScreen from 'hooks/useScreen';
import KeySellingPointsBarItem from '../KeySellingPointsBarItem';
import SwatchRequestIcon from '../icons/SwatchRequestIcon';
const itemTitle = 'Free Swatch Kit';
const itemContent = "Want to be sure you're choosing the right fabric? Order a free swatch kit to experience our fabrics up close and personal!";
const FreeSwatchKitItem = t0 => {
  const $ = _c(17);
  const {
    openMobileModal
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [isOrderSwatchesSidebarOpen, setIsOrderSwatchesSidebarOpen] = useState(false);
  const {
    isMobileOrTablet
  } = useScreen();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SwatchRequestIcon color="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMobileOrTablet || $[2] !== openMobileModal) {
    t2 = <KeySellingPointsBarItem icon={t1} onClick={() => {
      if (isMobileOrTablet) {
        openMobileModal({
          content: itemContent,
          icon: <SwatchRequestIcon color="white" />,
          cta: <CtaButton onClick={() => {
            setIsOrderSwatchesSidebarOpen(true);
          }} styling="solid-button" color="brand">Order Free Swatches</CtaButton>
        });
      } else {
        setIsOpen(true);
      }
    }}>{itemTitle}</KeySellingPointsBarItem>;
    $[1] = isMobileOrTablet;
    $[2] = openMobileModal;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SwatchRequestIcon color="white" />;
    t4 = () => {
      setIsOpen(false);
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-6"><CtaButton onClick={() => {
        setIsOrderSwatchesSidebarOpen(true);
        setIsOpen(false);
      }} styling="solid-button" color="brand">Order Free Swatches</CtaButton></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isOpen) {
    t6 = <StandardModal isOpen={isOpen} icon={t3} onClose={t4} title={itemTitle}>{itemContent}{t5}</StandardModal>;
    $[7] = isOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsOrderSwatchesSidebarOpen(false);
    };
    t8 = () => {
      setIsOrderSwatchesSidebarOpen(false);
    };
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isOrderSwatchesSidebarOpen) {
    t9 = <PDPOrderSwatchesSidebar show={isOrderSwatchesSidebarOpen} onClose={t7} closeSlidePanel={t8} />;
    $[11] = isOrderSwatchesSidebarOpen;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t2 || $[14] !== t6 || $[15] !== t9) {
    t10 = <>{t2}{t6}{t9}</>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export default FreeSwatchKitItem;